export default "__VITE_ASSET__fjBuKJlR__"